import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export function RetryMessage(props) {
  const { message, retry } = props;
  return (
    <Box
      sx={{ margin: 4, cursor: 'pointer', textAlign: 'center' }}
      onClick={retry}
    >
      <Typography>{message}</Typography>
      <Typography>Haga click aquí para reintentar</Typography>
    </Box>
  );
}

export default RetryMessage;
